// extracted by mini-css-extract-plugin
export default {"custom-dropdown":"InfoOrder_custom-dropdown__fx8pw","item":"InfoOrder_item__0rn+f"};